import React from 'react';
import { AIMessage } from '@bingads-webui/ads-copilot-ui';
import { useI18nContext } from '@bingads-webui/copilot-i18n';

export const ENGLISH_ONLY_SUPPORTED_LOCALES = ['zh-cn'];

interface ILiveAgentSupportClosedProps {
  placeholderTime: string;
  placeholderTimezone: string;
  customPlaceholder?: string;
  onFeedbackButtonClick: any;
}

interface ILiveAgentUnsupportedProps {
  onFeedbackButtonClick: any;
}

export const LiveAgentSupportClosed: React.FC<ILiveAgentSupportClosedProps> = ({
  placeholderTime, placeholderTimezone, customPlaceholder, onFeedbackButtonClick,
}) => {
  const i18n = useI18nContext()!;
  const textMessage = customPlaceholder
    ? i18n.getString(customPlaceholder)
    : i18n.getString(
      _TL_('We\'re sorry-the live chat is closed.<br /><br />Hours:<br />Mon-Fri: {{placeholderTime}}<br />Sat-Sun: Closed<br />*Note:* These hours are in the {{placeholderTimezone}} zone.<br /><br />Copilot in the Microsoft Advertising Platform is available all day. Please feel free to ask me a question to receive quick assistance.'),
      { placeholderTime, placeholderTimezone },
    );

  return (
    <div style={{ display: 'flex', float: 'left', flexDirection: 'column' }}>
      <AIMessage
        className="ai-message-live-agent"
        message={{
          text: textMessage,
        } as any}
        showReferences={false}
        showCopyButton={false}
        onFeedbackButtonClick={onFeedbackButtonClick}
      />
    </div>
  );
};

export const LiveAgentUnsupported: React.FC<ILiveAgentUnsupportedProps> = ({ onFeedbackButtonClick }) => {
  const i18n = useI18nContext()!;
  return (
    <div style={{ display: 'flex', float: 'left', flexDirection: 'column' }}>
      <AIMessage
        className="ai-message-live-agent"
        message={{
          text: i18n.getString(_TL_('I\'m sorry, the live chat isn\'t available in your country/region. Please feel free to ask me a question to receive quick assistance.')),
        } as any}
        showReferences={false}
        showCopyButton={false}
        onFeedbackButtonClick={onFeedbackButtonClick}
      />
    </div>
  );
};
